module.exports = __webpack_public_path__ + "static/ig-banner-vertical-69d786c80c339341e08e606b7faa8d5d.jpg";